import clientConfigApi from '../../config/config'

export const setRoomControlPage = (page) => {
    return {
        type: 'Set_Room_Control_Page',
        payload: page
    }
}

export const setNavItemExplore = (navItem) => {
    return {
      type: 'Set_Nav_Item_Explore',
      payload: navItem
    }
  }
  
export const setNavItemMystay = (navItem) => {
    return {
        type: 'Set_Nav_Item_Mystay',
        payload: navItem
    }
}

export const setChatWidgetInnitialized = bool => {
    return {
        type: "Set_Chat_Widget_Innitialized",
        payload: bool
    }
}

/**
 * set widget Navigation item List
 */
export const setNavItemList = (navItem) =>{
    return {
        type: 'Set_Nav_Item_List',
        payload: navItem
    }
}

/**
 * set widget list of to current selected tabs widget list.
 */
export const setCurrentTabNavItemList = (navItem) =>{
    return {
        type: 'Set_Current_Tab_Nav_Item_List',
        payload: navItem
    }
}

export const setShowDoorKeyPopup = (bool) => {
    return{
        type:"Set_show_door_key_popup",
        payload:bool
    }
}

export const setGuestDeviceLang = (lang) => {
    return{
        type:"Set_Guest_Device_Lang",
        payload:lang
    }
}

export const setNewHeader = (bool) => {
    return{
        type:"Set_New_Header",
        payload:bool
    }
}

export const setCurrentLoggedInGuestDetails = obj => {
    return{
        type: "Set_Current_Logged_In_Guest_Details",
        payload: obj
    }
}

export const setMakeUserLoginViaFindReservation = (bool)=>{
    return{
        type:"SET_MAKE_USER_LOGIN_VIA_FIND_RESERVATION",
        payload:bool
    }
} 

export const setDeviceConfifApiCall = (val) =>{
    return {
        type: 'Set_deviceConfifApiCall',
        payload: val
    }
}
